/**
 * Use in the `default` branch of an exhaustive switch/if-else chain.
 * TypeScript will error at compile time when a new union member is not handled.
 *
 * @example
 * switch (key) {
 *   case 'a': …; break;
 *   default: assertNever(key);
 * }
 */
export function assertNever(value: never): never {
  throw new Error(`Unhandled case: ${JSON.stringify(value)}`);
}
